module.exports = __webpack_public_path__ + "img/zoho-inactive-odd-line.589fb661.svg";